// Returns #000 or #fff — whichever contrasts better against the provided swatch background.
// Based on WCAG 2.1 relative luminance: https://www.w3.org/TR/WCAG21/#dfn-relative-luminance
function getStrikethroughColor(swatch) {
  // getComputedStyle normalizes any color format to rgb()/rgba()
  const match = getComputedStyle(swatch).backgroundColor.match(
    /rgba?\((\d+),\s*(\d+),\s*(\d+)/,
  );
  if (!match) return null; // transparent — leave empty to leverage CSS based fallback

  // sRGB gamma expansion
  const toLinear = (c) => {
    const s = c / 255;
    return s <= 0.04045 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4);
  };

  // apply human eye sensitivity weights (green-dominant)
  const lum =
    0.2126 * toLinear(+match[1]) +
    0.7152 * toLinear(+match[2]) +
    0.0722 * toLinear(+match[3]);

  // 0.179 = equidistant contrast ratio between black and white
  return lum > 0.179 ? "#000000" : "#ffffff";
}

function updateSwatchStrikethroughColors(root) {
  (root || document)
    .querySelectorAll(".product__color-swatch")
    .forEach((swatch) => {
      // keep default strikethrough color for swatches using product image
      if (swatch.querySelector("img")) return;

      const color = getStrikethroughColor(swatch);
      if (color) swatch.style.setProperty("--strikethrough-color", color);
    });
}
